/*
 * @Author: jiyuhang
 * @LastEditors: jiyuhang
 * @Date: 2021-10-08 10:04:53
 * @LastEditTime: 2021-11-01 16:52:08
 * @FilePath: /inspector-m/src/index.js
 * @Description: In User Settings Edit
 */
import Vue from 'vue'
import router from '@/components/core/src/router/index'
import component from './components'
import store from './store'
import plugins from './plugins'
import Beidou from './plugins/Beidou'
// import Sentry from '@rrc-materials/sentry'
import { ISPRODUCTION } from '@/config/global.config'
// import Vconsole from 'vconsole'
// new Vconsole()
Vue.use(Beidou, {
  beidouConfig: {
    projectId: 345, // Beidou平台申请的ProjectId
    isProd: ISPRODUCTION, //  非必传， 是否将捕获的异常信息发送到北斗服务器   为true时 发送上报请求 默认为true
    isDebug: false, // 非必传  是否打印日志 为true时 打印 默认为false
    reportWebBreadcrumb: true,
    overtime: 20000
  }
})

// Vue.use(Sentry, {
//   enabled: Object.is(process.env.ANNE_APP_MODE, 'pro'), // 该条件为只有生产环境上报
//   dsn: 'https://8b640535e46e40feb3cbca6bc55e2bc7@sentry.58.com/203', // 项目 dsn
//   release: process.env.ANNE_APP_RELEASE, // 配合 @anejs/anne-plugin-sentry 使用。若不上传source-map，可以不使用该参数
//   environment: process.env.ANNE_APP_MODE, // 环境类型
//   router // 路由信息, new Router({...})
// })

Vue.use(component, {
  router
})
Vue.use(plugins)

// 因为大部分情况下 不会使用请手动去除注释启用
// import('vconsole').then(VConsole => {
//   new VConsole() // eslint-disable-line
// })

// eslint-disable-next-line no-empty-function
window.bannerNight = () => {} // 为了兼容vivo手机的报错

Vue.config.productionTip = Object.is(process.env.NODE_ENV, 'development')

const app = new Vue({
  store,
  router
}).$mount('#app')

export default app
